import React from 'react';
import * as styles from './index.module.less';
import { H4 } from '@/components';
import CommonBlok from '@/components/common-blok';
import Statistics from '../statistics';
import { ReactComponent as LineLeftDeco } from '@/images/svg/line-left-deco.svg';
import { ReactComponent as LineRightDeco } from '@/images/svg/line-right-deco.svg';

const StatisticsWrapper = () => {
  return (
    <CommonBlok className={styles.statistics_part} isNewLayout paddingBottom="0">
      <div className={styles.statistics_container}>
        <div className={styles.honor_title_container}>
          <LineLeftDeco stroke="#7B838C" />
          <H4>
            企業
            <wbr />や<wbr />
            分野
            <wbr />を<wbr />
            問わず延べ
            <wbr />
            500万人
            <wbr />
            以上
            <wbr />の<wbr />方<wbr />に<wbr />
            ご利用
            <wbr />
            いただいて
            <wbr />
            おります
          </H4>
          <LineRightDeco stroke="#7B838C" />
        </div>
        <Statistics />
        <div className={styles.statistics_tips}>
          ※1. 2024年5月15日時点のデータです
          <br />
          ※2.
          当社調べ。静かな会議室（環境音が約40db）で、話者と外部マイクとの距離が1mで、４名の会話（発言がかぶらないようにする）をテキスト化した結果。実際の精度は話し方や音環境により大きく変わります。詳しくは
          <a href="/how-to-improve-transcription-accuracy">こちら</a>→
        </div>
      </div>
    </CommonBlok>
  );
};
export default StatisticsWrapper;
